import React from "react";
import * as Scrivito from "scrivito";
import { Container } from "reactstrap";
import { Form, Formik } from "formik";
import { ObjValidator } from "components";
import {
  CustomProductHeader,
  CustomProductBody,
} from "components/CustomProduct";
import { validateWithZod } from "utils";
import { NodeKinds } from "interfaces/enums";
import { CustomProductFormSchema } from "./schema";

export const CustomProductItem = Scrivito.connect(() => {
  const {
    productDescription = "",
    kind,
    price,
    productName,
    presentation,
    priceGroup,
    projectId,
    id: customProductId,
  } = Scrivito.currentPageParams();

  const initialPrice = !Number.isNaN(Number(price))
    ? parseFloat(price / 100).toFixed(2)
    : parseFloat(0).toFixed(2);

  const description = productDescription
    .replace(/^Specification Text:\s*{/, "")
    .replace(/}$/, "");

  const initialValues = {
    title: productName ?? "",
    ordercode: presentation ?? "",
    price: initialPrice,
    priceGroup: priceGroup ?? "",
    description,
  };

  const isDisabled =
    kind === NodeKinds.TROX_NETCOM_PRODUCT ||
    kind === NodeKinds.TROX_NETCOM_NOTE ||
    kind === NodeKinds.TROX_NETCOM_GENERIC_PRODUCT;

  return (
    <div className="pt-6 bg-gray-100 h-100">
      <Container>
        <Formik
          initialValues={initialValues}
          validate={validateWithZod(CustomProductFormSchema)}
        >
          <Form>
            <CustomProductHeader
              isDisabled={isDisabled}
              projectId={projectId}
              customProductId={customProductId}
            />
            <CustomProductBody
              isDisabled={isDisabled}
              customProductId={customProductId}
            />
          </Form>
        </Formik>
      </Container>
    </div>
  );
});

const CheckedPage = (props) => (
  <ObjValidator {...props}>
    <CustomProductItem {...props} />
  </ObjValidator>
);

export default CheckedPage;
Scrivito.provideComponent("CustomProductItem", CheckedPage);
